        <!-- ========================  404 ======================== -->

        <section class="not-found">
            <div class="container">
                <h1 class="title" data-title="404">404</h1>
                <div class="h4 subtitle">Sorry! Page not found.</div>
                <p>The requested URL was not found on this server.</p>
                <!-- <p>Click <a href="#">here</a> to get to the front page? </p> -->
            </div>
        </section>




// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/not-found/not-found.component.html